import type { Locale } from '../constants';
import { DEFAULT_LOCALE } from '../constants';
import { PREFERRED_LOCALE_COOKIE_NAME } from '../usePreferredLocale';

export function setMockPreferredLocale(locale: Locale = DEFAULT_LOCALE): void {
  Object.defineProperty(window.document, 'cookie', {
    writable: true,
    value: `${PREFERRED_LOCALE_COOKIE_NAME}=${locale}`,
  });
}
